import React from 'react';
import { Tooltip } from 'antd';

type Props = {
  negativeAt?: string | null;
  reasonMessages: string[];
  children: React.ReactElement;
};

const NegativeProposalStatusTooltip: React.FC<Props> = ({ negativeAt, reasonMessages, children }) => {
  const date = negativeAt ? new Date(negativeAt) : null;
  const formattedDate = date && !Number.isNaN(date.getTime())
    ? new Intl.DateTimeFormat('tr-TR', {
      timeZone: 'Europe/Istanbul',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23',
    }).format(date).replace(/\./g, '/')
    : null;

  return (
    <Tooltip title={
      <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        <span>{formattedDate
          ? `Olumsuza geçiş tarihi: ${formattedDate}`
          : 'Olumsuza geçiş tarihi kayıtlı değil.'}</span>
        {reasonMessages.map((message, index) => <span key={index}>{message}</span>)}
      </div>
    }>
      {children}
    </Tooltip>
  );
};

export default NegativeProposalStatusTooltip;
